import { FindParamsDefault } from './find-params-default';

export interface FindParamsItems extends FindParamsDefault {
  primary_similar?: string;
}
